import Vue from 'vue'
import VueRouter from 'vue-router'
import {auth as authService, auth} from './../services'

Vue.use(VueRouter);

const routes = [];

const router = new VueRouter({
    routes,
    mode: 'history',
    routeCollection: [],
})

router.getMenu = () => {
    let _self = router.app;
    return _self.$http.get(_self.$http.options.root + '/menu/get').then((response) => {
        let routes = [];
        response.data.routes.forEach(function(v) {
            if (router.options.routeCollection.indexOf(v.name) > -1) {
                return;
            }
            routes.push({
                path: v.href,
                name: v.name,
                component: lazyLoading(v.type + '/' + v.component + '/' + v.bundle),
                meta: v.meta
            });
            router.options.routeCollection.push(v.name);
        });
        _self.$menu = response.data.menu;
        _self.$userMenu = response.data.userMenu;
        _self.$userMetadata = response.data.userMetadata;
        _self.$projectMetadata = response.data.projectMetadata;

        if (routes.length > 0) {
            _self.$routes = routes;
            router.addRoutes(routes);
        }

        if (!response.data.menu) {
            authService.clearLocalStorage();
        }

        if (router.options.routeCollection.indexOf('redirect') === -1) {
            //redirect to home when not found
            router.addRoutes([{
                name: 'redirect',
                path: '*',
                beforeEnter(to) {
                    router.push({name: response.data.menu ? router.getHomeName() : router.getSignInName()});
                }
            }]);
            router.options.routeCollection.push('redirect');
        }
    });
};

const lazyLoading = (path) => {
    return (resolve) => {
        require([`./../${path}.vue`], resolve)
    }
};

router.getHomeLink = () => {
    let link = router.app.$routes.filter((r) => {
        return r.meta.home;
    });

    return link.length > 0 ? link.shift().path : '/';
};

router.getHomeName = () => {
    let link = router.app.$routes.filter((r) => {
        return r.meta.home;
    });

    return link.length > 0 ? link.shift().name : '/';
};

router.getSignInLink = () => {
    let link = router.app.$routes.filter((r) => {
        return r.meta.signin;
    });

    return link.length > 0 ? link.shift().path : '/signin';
};

router.getSignInName = () => {
    let link = router.app.$routes.filter((r) => {
        return r.meta.signin;
    });

    return link.length > 0 ? link.shift().name : 'signin';
};

router.getLogoutLink = () => {
    let link = router.app.$routes.filter((r) => {
        return r.meta.logout;
    });

    return link.length > 0 ? link.shift().path : '/logout';
};

router.getLogoutName = () => {
    let link = router.app.$routes.filter((r) => {
        return r.meta.logout;
    });

    return link.length > 0 ? link.shift().name : 'logout';
};

router.beforeEach((to, from, next) => {
    if (typeof Vue.http.abortPrevRequests === 'function') {
        Vue.http.abortPrevRequests();
    }
    // if (to.matched.some(record => !record.meta.isPublic)) {
    if (to.matched.some(record => record.name !== router.getSignInName())) {
        if (!auth.isLogged()) {
            return next({
                name: router.getSignInName(),
                query: {redirect: to.fullPath}
            })
        }
    }
    next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js